export default "__VITE_ASSET__D1xJFHM7__"